import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
  MatSnackBar,
} from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subscription, take, finalize } from 'rxjs';
import { UniqueIdService } from 'src/app/modules/services/unique-id/unique-id.service';
import { UserService } from 'src/app/modules/services/user/user.service';
import { LoadingService } from '../../loading/loading.service';
import { AlertComponent } from '../../alert/alert.component';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss'],
})
export class CreateUserComponent implements OnInit {
  hide = true;
  public id: string;
  subsctiptions: Subscription[] = [];
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  form: FormGroup;

  constructor(
    private cdr: ChangeDetectorRef,
    private uniqueIdService: UniqueIdService,
    private fb: FormBuilder,
    private userService: UserService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private loadingService: LoadingService
  ) {
    this.id = this.uniqueIdService.generateUniqueIdWithPrefix('login');
    this.form = this.fb.group({
      nome: [null, [Validators.required, Validators.minLength(3)]],
      email: [null, [Validators.required, Validators.email]],
    });
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }
  onSubmit() {
    const form = this.form.value;
    this.loadingService.showLoading();

    this.subsctiptions.push(
      this.userService
        .createUser(form)
        .pipe(
          take(1),
          finalize(() => {
            this.loadingService.hideLoading();
          })
        )
        .subscribe(
          (response) => {
            this.openSnackBar('Usuário cadastrado com sucesso. .', 'sucess');
            this.goToListUser();
          },
          (erro) => {
            if (erro.status !== 500 && erro.status) {
              this.openSnackBar(erro.error.message, 'error');
            }
            if (erro.error.error == 'Unprocessable Entity') {
              this.openSnackBar(erro.error.message, 'warning');
            } else {
              this.openSnackBar(
                'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
                'error'
              );
            }
          }
        )
    );
  }
  goToListUser() {
    this.router.navigate(['/usuarios']);
  }
  openSnackBar(description: string, type: string) {
    let classSnack = '';
    switch (type) {
      case 'sucess':
        classSnack = 'snacbar-sucess';
        break;
      case 'warning':
        classSnack = 'snacbar-warning';
        break;
      case 'error':
        classSnack = 'snacbar-error';
        break;
    }
    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description: description, type: type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
}
